function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';
import { Accordion, AccordionContext, Button as BootstrapButton, Card, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { showModal, toggleLayersPanelVisibility } from '../../../redux/actions';
import text from '../../../text';
import CollapseButton from '../../button/CollapseButton';
import Icon from '../../icon/Icon';
import { DELETE_SHAPES_MODAL } from '../../modal/DeleteShapesModal';
import { MapViewContext } from '../mapViewContext';
import DownloadsMenu from './DownloadsMenu';
import Layer from './Layer';
/* eslint-disable react/prop-types */ var GuideToggle = function(param) {
    var children = param.children, eventKey = param.eventKey;
    var currentEventKey = useContext(AccordionContext);
    var isCurrentEventKey = currentEventKey === eventKey;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, children), /*#__PURE__*/ React.createElement(BootstrapButton, {
        variant: "light",
        className: "toggle-button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: isCurrentEventKey ? 'caret-down' : 'caret-up'
    })));
};
var LayersPanel = function(param) {
    var onMenuClick = param.onMenuClick;
    var _state_selections;
    var _useContext = useContext(MapViewContext), actions = _useContext.actions, state = _useContext.state;
    var dispatch = useDispatch();
    var toggleAllSelections = function(visible) {
        var _state_selections;
        actions.setSelections(((_state_selections = state.selections) === null || _state_selections === void 0 ? void 0 : _state_selections.map(function(selection) {
            return _object_spread_props(_object_spread({}, selection), {
                visible: visible,
                focused: false
            });
        })) || []);
        actions.setActiveSelectionId(null);
        actions.setGeometriesToLoad({});
    };
    var isAllSelectionsVisible = state.selections ? state.selections.every(function(selection) {
        return selection.visible;
    }) : false;
    var isAllSelectionsHidden = state.selections ? state.selections.every(function(selection) {
        return !selection.visible;
    }) : false;
    var eyeOffIcon = useMemo(function() {
        return isAllSelectionsHidden ? 'eye-slash' : 'eye-mixed-state';
    }, [
        isAllSelectionsHidden
    ]);
    var layout = useSelector(function(reduxState) {
        return {
            layout: reduxState.layout
        };
    }).layout;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('layers-panel-container', {
            show: layout.layersPanel.isVisible
        })
    }, /*#__PURE__*/ React.createElement(CollapseButton, {
        id: "layersPanelCollapseButton",
        openDirection: "right",
        isOpen: layout.layersPanel.isVisible,
        closeText: text('layers'),
        onClick: function() {
            return dispatch(toggleLayersPanelVisibility(!layout.layersPanel.isVisible));
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "layers-panel"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "panel-header"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "panel-heading"
    }, "Layers"), /*#__PURE__*/ React.createElement("div", {
        className: "panel-actions"
    }, /*#__PURE__*/ React.createElement(BootstrapButton, {
        className: "panel-action",
        variant: "light",
        // If all selections are visible, hide them all
        // otherwise; show them
        onClick: function() {
            return toggleAllSelections(!isAllSelectionsVisible);
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: classNames(_define_property({}, 'original', !isAllSelectionsVisible)),
        icon: isAllSelectionsVisible ? 'eye' : eyeOffIcon
    })), /*#__PURE__*/ React.createElement(Dropdown, null, /*#__PURE__*/ React.createElement(Dropdown.Toggle, {
        variant: "light",
        className: "panel-action"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "download"
    })), /*#__PURE__*/ React.createElement(Dropdown.Menu, null, /*#__PURE__*/ React.createElement(DownloadsMenu, {
        selections: state.selections
    }))), /*#__PURE__*/ React.createElement(BootstrapButton, {
        className: "panel-action",
        variant: "light",
        onClick: function() {
            return dispatch(showModal(DELETE_SHAPES_MODAL, {
                selectionsToDelete: state.selections
            }));
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "trash"
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-fill overflow-auto"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "layers"
    }, ((_state_selections = state.selections) === null || _state_selections === void 0 ? void 0 : _state_selections.length) > 0 && state.selections.map(function(selection, i) {
        return /*#__PURE__*/ React.createElement(Layer, {
            onMenuClick: onMenuClick,
            key: selection.id,
            data: selection,
            index: i
        });
    }))), /*#__PURE__*/ React.createElement(Accordion, {
        defaultActiveKey: "0"
    }, /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Accordion.Toggle, {
        as: Card.Header,
        eventKey: "0"
    }, /*#__PURE__*/ React.createElement(GuideToggle, {
        eventKey: "0"
    }, /*#__PURE__*/ React.createElement("h6", null, text('guide')))), /*#__PURE__*/ React.createElement(Accordion.Collapse, {
        eventKey: "0"
    }, /*#__PURE__*/ React.createElement(Card.Body, null, text('guideInstructions', {
        emphasizeText1: /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold"
        }, "Shapes"),
        emphasizeText2: /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold"
        }, "Draft"),
        emphasizeText3: /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold"
        }, "type"),
        emphasizeText4: /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold"
        }, "Cart"),
        emphasizeText5: /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold"
        }, "Check-out")
    })))))));
};
export default LayersPanel;
